// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"CombinedTooltip_tooltip-wrapper__feCfv","label":"CombinedTooltip_label__Bi3Ww"};